export const ROW_HEIGHT = 66;

export const CHECKBOX_BOX = {
	width: 26
};
